import requests from "./httpService";

const SeoVirtualServices = {
  
  getAllSeoVirtual: async () => {
    return requests.get(`/klite/virtual/`);
  },
  addSeoVirtual: async (body) => {
    return requests.post(`/klite/virtual/add`, body);
  },
  getSeoVirtualById: async (id) => {
    return requests.get(`/klite/virtual/${id}`);
  },
  updateSeoVirtual: async (id, body) => {
    return requests.put(`/klite/virtual/${id}`, body);
  },
  deleteSeoVirtual: async (id) => {
    return requests.delete(`/klite/virtual/${id}`);
  },
  getAllContact: async () => {
    return requests.get(`/klite/contact/`);
  },
  getcontactById: async (id) => {
    return requests.get(`/klite/contact/${id}`);
  },
  updateContactStatus: async (id) => {
    return requests.patch(`/klite/contact/${id}/connected`);
  }
};

export default SeoVirtualServices;
